import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var GenericDocsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function GenericDocsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Create a new generic doc
     *
     * @since 1.0.0
     *
     * @param data GenreicDoc data
     * @returns Observable<any>
     */
    GenericDocsService.prototype.create = function (data) {
        return this.apiService.apiCall("POST", "generic-docs", data);
    };
    /**
     * Get Groundings list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    GenericDocsService.prototype.getList = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "generic-docs/" + companyId, params);
    };
    /**
     * Get the generic doc
     *
     * @since 1.0.0
     *
     * @param docId GenreicDoc Id
     * @returns Observable<any>
     */
    GenericDocsService.prototype.get = function (companyId, docId) {
        return this.apiService.apiCall("GET", "generic-docs/" + companyId + "/" + docId);
    };
    /**
     * Get the generic doc
     *
     * @since 1.0.0
     *
     * @param docId GenreicDoc Id
     * @returns Observable<any>
     */
    GenericDocsService.prototype.getDocByView = function (docId) {
        return this.apiService.apiCall("GET", "generic-docs/doc-by-view/" + docId);
    };
    /**
     * Update a generic doc
     *
     * @since 1.0.0
     *
     * @param data GenreicDoc data
     * @returns Observable<any>
     */
    GenericDocsService.prototype.update = function (companyId, docId, data) {
        return this.apiService.apiCall("PATCH", "generic-docs/" + companyId + "/" + docId, data);
    };
    /**
     * Delete a generic doc
     *
     * @since 1.0.0
     *
     * @param data GenreicDoc data
     * @returns Observable<any>
     */
    GenericDocsService.prototype.delete = function (companyId, docId) {
        return this.apiService.apiCall("DELETE", "generic-docs/" + companyId + "/" + docId);
    };
    /**
     * This gets the occupied space of generic documents, in the measure of MB or GB
     *
     * @since 1.0.0
     */
    GenericDocsService.prototype.getOccupiedSpace = function (companyId) {
        return this.apiService.apiCall('GET', "generic-docs/occupied-space/" + companyId);
    };
    /**
     * Get an exportation file of all generic docs
     *
     * @since 1.0.0
     */
    GenericDocsService.prototype.getExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "generic-docs/export/" + companyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    GenericDocsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GenericDocsService_Factory() { return new GenericDocsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: GenericDocsService, providedIn: "root" });
    return GenericDocsService;
}());
export { GenericDocsService };
